import { ListSubheader, styled } from "common/components";

export const StyledListCategory = styled(ListSubheader)(({ theme }) => ({
  padding: theme.spacing(0.25, 0, 0, 0),
  lineHeight: theme.typography.h6.lineHeight,
  fontSize: theme.typography.h6.fontSize,
  color: theme.palette.grey[700],
}));
